<template>
  <div v-if="about">
    <h3 class="mb-5">Leading of the Edge</h3>
    <div class="h4 mb-5">
      顯示於AboutUs頁面，可擴充添加，建議最多3個
    </div>

    <!-- Items -->
    <PageCollapse v-for="(item, i) in about.partners" :key="i">
      <template v-slot:head>
        <h3 class="mr-auto">Item {{ i + 1 }}</h3>
      </template>
      <template v-slot:actions>
        <div class="ml-auto">
          <button class="btn square mr-10px" @click="deleteItem(item)">
            <v-icon class="ink-02-medium--text">delete</v-icon>
          </button>
          <button class="btn square mr-10px" @click="downItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
          </button>
          <button class="btn square" @click="upItem(item, i)">
            <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
          </button>
        </div>
      </template>
      <template v-slot:body>
        <!-- Title -->
        <label class="form-item d-flex pt-3">
          <h4 class="w-180px mt-5">Title</h4>
          <div class="flex-grow-1 mt-3">
            <v-text-field
            v-model="item.title"
            outlined
            dense
          ></v-text-field>
          </div>
        </label>
        <!-- Endorsement -->
        <label class="form-item d-flex pt-3">
          <h4 class="w-180px mt-5">Description</h4>
          <div class="flex-grow-1 mt-3">
            <v-textarea
              v-model="item.endorsement"
              outlined
              dense
            ></v-textarea>
          </div>
        </label>
        <!-- img uploader -->
        <div class="d-flex px-5 pt-5 mb-8">
          <div class="w-180px">
            <h4 class="mb-10px">Banner</h4>
            <div class="h5 ink-02-medium--text">
              建議尺寸：1065px * 585px <br />
              檔案大小限制：≤ 1 MB <br />
              支援格式：.png/.jpg/.gif
            </div>
          </div>
          <div class="d-flex justify-end flex-grow-1">
            <ImgUploader
              :imageUrl.sync="item.logo"
              dir="about"></ImgUploader>
          </div>
        </div>
      </template>
    </PageCollapse>

    <!-- add team sponsorship -->
    <div class="mt-5">
      <button class="btn btn-outlined w-100 justify-start" @click="addItem">
        <v-icon class="primary--text mr-2">add_circle</v-icon>
        <span>添加 Item</span>
      </button>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
  },
  methods: {
    addItem() {
      const template = {
        endorsement: '',
        companyLogo: '',
      };
      this.about.partners.push(template);
    },
    deleteItem(item) {
      const index = this.about.partners.map((i) => i.id).indexOf(item.id);
      this.about.partners.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.about.partners.length - 1) {
        this.about.partners.splice(i, 1);
        this.about.partners.unshift(item);
        return;
      }
      // item become next index
      this.about.partners.splice(i, 1);
      this.about.partners.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.about.partners.splice(i, 1);
        this.about.partners.push(item);
        return;
      }
      // item become previous index
      this.about.partners.splice(i, 1);
      this.about.partners.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
